import {
  Box,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import deletebox from "../../Utils/Images/deletebox.png";
import editbox from "../../Utils/Images/editbox.png";
import eyebox from "../../Utils/Images/eyebox.png";
import { Link } from "react-router-dom";
import { handleDeleteRecipe } from "../../APIs/Function/Workout/Recipe/DeleteRecipe";
import { GetRecipe } from "../../APIs/Function/Workout/Recipe/GetRecipe";
import DeleteModal from "../Modal/DeleteModal";
import Loader from "../Loader/Loader";

const RecipeTable = ({
  setRecipeData,
  RecipeData,
  loadinga,
  Column1,
  Column2,
  column3,
  Column4,
}) => {
  const [modalID, setModalID] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await handleDeleteRecipe(modalID);
    let res = await GetRecipe();
    setRecipeData(res.r);
    alert("Recipe Delete Successfully");
    setLoading(false);
    setOpen(false);
  };
  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  console.log(RecipeData)
  return (
    <>
      {loadinga || loading ? (
        <Box sx={{ mt: "25%" }}>
        <Loader />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "30px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column1}
                  </Typography>
                </Paper>
              </Grid>

              {/* Second Column */}

              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column2}
                  </Typography>
                </Paper>
              </Grid>

              {/* Third Column */}

              <Grid item xs={7.5} md={7.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {column3}
                  </Typography>
                </Paper>
              </Grid>

              {/* Fourth Column */}

              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column4}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{ border: "0.5px solid #DDDDDD",
              overflow: "auto",
              minHeight: "100px",
              maxHeight: "415px",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                {RecipeData?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {i + 1}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Second Column */}

              <Grid item xs={2} md={2}>
                {RecipeData.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={{ width: "40px", height: "40px" }}>
                      <img
                        width={"100%"}
                        height={"100%"}
                        src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.recipe_images[0].r_images}`}
                        alt=""
                      />
                    </Box>
                  </Paper>
                ))}
              </Grid>

              {/* Third Column */}

              <Grid item xs={7.5} md={7.5}>
                {RecipeData.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.title}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Sixth Column */}
              <Grid item xs={2} md={2}>
                {RecipeData.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        alignItems: "center",
                        display: "flex",
                        width: "100%",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <Link to={`/singlerecipe/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={eyebox}
                            alt="logo"
                          />
                        </Link>
                      </Box>

                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <Link to={`/Editrecipeplans/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={editbox}
                            alt="logo"
                          />
                        </Link>
                      </Box>

                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <img
                          width={"100%"}
                          height={"100%"}
                          src={deletebox}
                          alt=""
                          onClick={() => handleModal(e.id)}
                        />
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
    </>
  );
};

export default RecipeTable;
